import { render, staticRenderFns } from "./EditarPedidoPanel.vue?vue&type=template&id=34fe9658&scoped=true&"
import script from "./EditarPedidoPanel.vue?vue&type=script&lang=js&"
export * from "./EditarPedidoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fe9658",
  null
  
)

export default component.exports